module.exports = __webpack_public_path__ + "img/lead-service2.a0fb5353.jpg";